/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import { Image } from '@adc/ui-core'
import ADCInlineMonoLight from '../../images/logo/adc/inline-mono-light.svg'
import MorphInlineDark from '../../images/logo/morpheus/inline-dark.svg'
import MorphInlineLight from '../../images/logo/morpheus/inline-light.svg'
import MorphStackDark from '../../images/logo/morpheus/stack-dark.svg'
import MorphStackLight from '../../images/logo/morpheus/stack-light.svg'

const ADC_INLINE_MONO_LIGHT = props => (
  <Image src={ADCInlineMonoLight} {...props} />
)

const MORPH_INLINE_DARK = props => <Image src={MorphInlineDark} {...props} />

const MORPH_INLINE_LIGHT = props => <Image src={MorphInlineLight} {...props} />

const MORPH_STACK_DARK = props => <Image src={MorphStackDark} {...props} />

const MORPH_STACK_LIGHT = props => <Image src={MorphStackLight} {...props} />

export default {
  ADC_INLINE_MONO_LIGHT,
  MORPH_INLINE_DARK,
  MORPH_INLINE_LIGHT,
  MORPH_STACK_DARK,
  MORPH_STACK_LIGHT,
}
